import { TShowPhoneAction } from '../../types/analytics/call';
import { TRequestCallbackOpener } from '../../types/microfrontends/newbuildingCallbackWidget';

export type TPlaceType = 'airphoto';

interface IContactsButtons {
  callAction: TShowPhoneAction;
  callbackOpener: TRequestCallbackOpener;
}

export const ACTIONS_MAP: Record<TPlaceType, IContactsButtons> = {
  airphoto: { callAction: 'Open_airphoto', callbackOpener: 'airphoto' },
};
